import clsx from 'clsx'

export const buttonVariants = ({ variant = 'ghost' }: { variant: 'ghost' }) => {
  return clsx(
    'tw:whitespace-nowrap tw:rounded-md',
    'tw:focus:border-primary-500 tw:focus:ring-4 tw:focus:ring-primary-300',
    {
      ghost: 'tw:bg-transparent tw:hover:bg-primary-50',
    }[variant]
  )
}

